// extracted by mini-css-extract-plugin
module.exports = {"filterSubheading":"Settlements_filterSubheading__2BaeK","filterBody":"Settlements_filterBody__1zdHw"};